import { ReactNode } from "react";
import styled from "styled-components";

import InfoTip from "../InfoTip";

const Card = styled.section`
  background: #ffffff;
  border: 1px solid #ece4da;
  border-radius: 16px;
  padding: 20px 22px;
  box-sizing: border-box;
  min-width: 0;
`;

const Head = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
`;

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const Title = styled.h2`
  font-family: 'Aileron', 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: #111111;
  margin: 0;
`;

const Subtitle = styled.p`
  font-family: 'Aileron', 'Poppins', sans-serif;
  font-size: 12.5px;
  color: #8a7f74;
  margin: 4px 0 0;
`;

interface PanelProps {
  title: string;
  subtitle?: string;
  info?: string;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
}

const Panel = ({ title, subtitle, info, action, children, className }: PanelProps) => (
  <Card className={className}>
    <Head>
      <div>
        <TitleRow>
          <Title>{title}</Title>
          {info && <InfoTip text={info} label={`About ${title}`} />}
        </TitleRow>
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
      </div>
      {action}
    </Head>
    {children}
  </Card>
);

export default Panel;
